import clsx from 'clsx';
import Link from '@/components/Link';

export default function TrainerListingAction({
  url,
  className,
  children,
  ...rest
}) {
  return (
    <Link
      href={url}
      className={clsx(
        'flex w-full items-center justify-center focus:outline-none px-4 py-2 lg:py-4 leading-8 font-medium lg:font-semibold lg:text-lg text-gray-800 hover:text-gray-900 hover:bg-green-50 focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 focus:bg-green-50 focus:text-green-600',
        className
      )}
      {...rest}
    >
      {children}
    </Link>
  );
}
